import React from 'react'
import "@/styles/loader.css"

function Loader() {
  return (
    <div className='loader'> </div>
  )
}

export default Loader